import { render, staticRenderFns } from "./KPIsClients.vue?vue&type=template&id=720fbfc4&"
import script from "./KPIsClients.vue?vue&type=script&lang=js&"
export * from "./KPIsClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports